<div
    #storyFullScreen
    tabindex="-1"
    class="st-story-item-full-screen-header"
    [dir]="dir()"
    [class.disabled]="isStoryDisabled()">
    <div class="st-story-item-full-screen-header__top-container">
        @if (data()) {
            <st-story-output-type
                class="st-story-item-full-screen-header__top-container__assignment-type"
                showLabel
                [showIcon]="false"
                [record]="data()"
                [disabled]="isStoryDisabled() || data()?.readOnlyCriteria?.[pstFieldNames.PSTStoryOutputType]"
                [value]="data()?.PSTStoryOutputType"
                (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.PSTStoryOutputType }])" />
        }
        @if (parentSubstoriesVisible() || isSubStory()) {
            <span class="st-story-item-full-screen-header__top-container__story-level-type-label">
                {{ isSubStory() ? languageSettings().PSTWebSecondaryStoryLabel : languageSettings().PSTWebPrimaryStoryLabel }}
            </span>
        }
        @if (data()?.ContainerTitle) {
            <span class="st-story-item-full-screen-header__top-container__rundown-name">{{ rundownTitleAndDate() }}</span>
        }
        @if (!isStoryInRO()) {
            <span class="st-story-item-full-screen-header__top-container__not-assigned">{{ languageSettings().PSTWebNotAssignedOption }}</span>
        }
        @if (!data()?.isNewRecord) {
            <div class="st-story-item-full-screen-header__top-container-time-updated">
                <span class="st-story-item-full-screen-header__top-container-time-updated__updated-label">{{ timeUpdatedLabel() }}</span>
                <span class="st-story-item-full-screen-header__top-container-time-updated__updated-by">{{ selectCurrentStoryModBy() }}</span>
            </div>
        }
    </div>
    <st-expansion-panel
        #paneContainer
        togglePosition="after"
        class="st-story-item-full-screen-header__expansion-panel-row"
        [class.st-story-item-full-screen-required]="!isRequiredFieldsPopulated() && enforceRequiredFieldsOnCreate()"
        [expanded]="data()?.isNewRecord">
        <div
            before
            class="st-story-item-full-screen-header__expansion-panel-row__before">
            @if (!standaloneStory()) {
                <button
                    st-click-stop-propagation
                    mat-icon-button
                    [matTooltip]="languageSettings().PSTWebBackButtonLabel"
                    (click)="backToTopic.emit()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
            }
            <mat-icon
                big
                class="st-story-item-full-screen-header__expansion-panel-row__drag-icon"
                st-click-stop-propagation
                [draggable]="isDragable()"
                (dragstart)="onDragStart($event, data())">
                drag_handle
            </mat-icon>
        </div>

        <span title>
            @if (data()) {
                <div class="st-story-item-full-screen-header__expansion-panel-row__title">
                    <st-text-area-overlay
                        #title
                        required
                        minRows="1"
                        maxRows="1"
                        minHeight="1rem"
                        maxLength="50"
                        maxOverlayRows="1"
                        class="st-story-item-full-screen-header__expansion-panel-row-title"
                        st-click-stop-propagation
                        panelClass="st-story-item-full-screen-header__expansion-panel-row-title"
                        [disabled]="isDisabled()"
                        [value]="data()?.Title || ''"
                        [placeholder]="languageSettings().PSTWebSlugPlaceholder"
                        (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.Title }])" />
                </div>
            }
        </span>
        <ng-container actions>
            <div class="st-story-item-full-screen-header__expansion-panel-row--actions">
                <button
                    st-click-stop-propagation
                    class="st-story-item-full-screen-header__expansion-panel-row--actions__publish-button"
                    mat-flat-button
                    [disabled]="isDisabled()">
                    Publish
                </button>
                @if (approvedVisible()) {
                    <button
                        class="st-story-item-full-screen-header__expansion-panel-row--actions-approve"
                        mat-icon-button
                        st-click-stop-propagation
                        [disabled]="isDisabled()"
                        [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames.Approved]?.DefaultCaption"
                        [class.st-story-item-full-screen-header__expansion-panel-row--actions-approve--active]="data()?.Approved"
                        (click)="updateCurrentStory([{ value: !data()?.Approved, key: pstFieldNames.Approved }])">
                        <mat-icon>done</mat-icon>
                    </button>
                }
                @if (!data()?.isNewRecord) {
                    <st-external-actions-overlay
                        st-click-stop-propagation
                        [inFullScreen]="true"
                        [disabled]="isDisabled()"
                        [data]="data()"
                        [editable]="true"
                        [hasUnsavedChanges]="hasUnsavedChanges()" />
                }
            </div>
        </ng-container>
        <ng-container>
            <div class="st-story-item-full-screen-header__expansion-panel-row--content">
                <st-tags-autocomplete
                    class="st-story-item-full-screen-header__expansion-panel-row--content-tags"
                    maxItemsToShow="100"
                    [value]="data()?.Tags"
                    [disabled]="isDisabled()"
                    [required]="fieldDefDict?.[pstFieldNames.PSTTags]?.Required"
                    [label]="fieldDefDict?.[pstFieldNames.PSTTags]?.DefaultCaption"
                    (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.PSTTags }])" />
                <div class="st-story-item-full-screen-header__expansion-panel-row--content-options">
                    <st-status
                        [fieldName]="pstFieldNames.PSTStoryStatus"
                        [value]="data()?.PSTStoryStatus"
                        [placeholder]="fieldDefDict?.[pstFieldNames.PSTStoryStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTStoryStatus)"
                        [disabled]="isDisabled()"
                        [required]="fieldDefDict[pstFieldNames.PSTStoryStatus]?.Required"
                        [data]="data()"
                        [itemType]="data()?.PSTStoryStatus?.id"
                        [statusFieldName]="pstFieldNames.PSTStoryStatus"
                        [addEmptyOption]="!fieldDefDict[pstFieldNames.PSTStoryStatus]?.Required"
                        (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.PSTStoryStatus }])" />
                    @if (fieldDefDict[pstFieldNames.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME) {
                        <st-date-time-picker
                            asCustomField
                            [disabled]="data()?.readOnlyCriteria?.[pstFieldNames.TargetPublicationDate] || isDisabled()"
                            [required]="enforceRequiredFieldsOnCreate() && fieldDefDict[pstFieldNames.TargetPublicationDate]?.Required"
                            [label]="fieldDefDict[pstFieldNames.TargetPublicationDate]?.DefaultCaption"
                            [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                            (timezoneChange)="timezoneChanged(pstFieldNames.TargetPublicationDate, $event)"
                            (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.TargetPublicationDate }])" />
                    } @else {
                        <st-date-picker
                            [required]="enforceRequiredFieldsOnCreate() && fieldDefDict[pstFieldNames.TargetPublicationDate]?.Required"
                            [label]="fieldDefDict[pstFieldNames.TargetPublicationDate]?.DefaultCaption"
                            [disabled]="data()?.readOnlyCriteria?.[pstFieldNames.TargetPublicationDate]"
                            [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                            (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.TargetPublicationDate }])" />
                    }
                    <st-desk
                        [value]="data()?.PSTGroup"
                        [data]="data()"
                        [fieldName]="pstFieldNames?.PSTDesk"
                        [disabled]="data()?.readOnlyCriteria?.[pstFieldNames.PSTDesk] || isDisabled()"
                        [required]="enforceRequiredFieldsOnCreate() && fieldDefDict?.[pstFieldNames.PSTDesk]?.Required"
                        [label]="fieldDefDict?.[pstFieldNames.PSTDesk]?.DefaultCaption"
                        [placeholder]="fieldDefDict?.[pstFieldNames.PSTDesk]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                        (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.PSTDesk }])" />
                    <st-staff-id-list
                        [value]="data()?.PSTStoryOwner"
                        [label]="fieldDefDict?.[pstFieldNames.PSTStoryOwner]?.DefaultCaption"
                        [disabled]="data()?.readOnlyCriteria?.[pstFieldNames.PSTStoryOwner] || isDisabled()"
                        [required]="enforceRequiredFieldsOnCreate() && fieldDefDict?.[pstFieldNames.PSTStoryOwner]?.Required"
                        (changed)="updateCurrentStory([{ value: $event, key: pstFieldNames.PSTStoryOwner }])" />
                    @if (parentSubstoriesVisible() || isSubStory()) {
                        @if (isSubStory()) {
                            <st-story-icon-list
                                addIcon="link"
                                enableMenu="false"
                                [parentLabel]="parentStory()?.Title"
                                [value]="parentStoryList()"
                                [cardDisabled]="isDisabled()"
                                (itemClicked)="openRelatedStory($event)" />
                        } @else {
                            <st-story-icon-list
                                maxItemsToShow="4"
                                [value]="subStories()"
                                [templates]="storyTemplates()"
                                [cardDisabled]="isDisabled()"
                                [topicEditable]="!isDisabled()"
                                [parentRecord]="data()"
                                [addLabelKey]="addSubStoryLabelKey"
                                (itemClicked)="openRelatedStory($event)"
                                (extraItemsClicked)="openSubStoriesInSidecar()"
                                (createStoryEvent)="createSubStory($event)" />
                        }
                    }
                </div>
            </div>
        </ng-container>
    </st-expansion-panel>
    @if (toggleEditor()) {
        <div class="st-story-item-full-screen-header-editor-options-container">
            <div class="st-story-item-full-screen-header-editor-options">
                @for (item of items(); track item.id) {
                    @if (item.isDirectAction) {
                        <button
                            mat-button
                            class="st-story-item-full-screen-header-editor-options__option"
                            [class.st-story-item-full-screen-header-editor-options__option-required]="item.isRequired"
                            (click)="onActionHandler(item)">
                            {{ item.label }}
                        </button>
                    } @else {
                        <button
                            mat-button
                            class="st-story-item-full-screen-header-editor-options__option"
                            [matMenuTriggerFor]="menu.baseMenu()">
                            {{ item.label }}
                        </button>
                        <st-toolbar-menu
                            #menu
                            [items]="item.options"
                            (action)="onActionHandler($event)" />
                    }
                }
            </div>
            <div class="st-story-item-full-screen-header-editor-options-collab-users">
                @for (user of collabUsers(); track $index) {
                    <st-avatar
                        big
                        [userId]="user.id" />
                }
            </div>
        </div>
    }
</div>
<div class="st-story-item-full-screen-body">
    <div class="st-story-item-full-screen-editor-container">
        @if (isLoading() || !data()) {
            <st-loader
                class="st-story-item-full-screen-loader"
                [diameter]="200"
                [productLabel]="languageSettings().PSTWebLoadingLabel"
                [strokeWidth]="10" />
        } @else {
            <st-story-editor
                [class.st-story-item-full-screen-editor--content-hidden]="!toggleEditor()"
                [story]="data()"
                [disabled]="editorDisabled()"
                [isEditableByLock]="isEditableByLock()"
                [hasUnsavedChanges]="hasUnsavedChanges()"
                (focusin)="onFocus()"
                (contentChanged)="onEditorContentChanged($event)"
                (save)="onEditorSave($event)"
                (selectedTextChange)="onSelectedTextChanged($event)"
                (lockStory)="lockStory()"
                (collabUsers)="onCollabUsersChanged($event)"
                (codoxInitializing)="isCodoxInitializing.set($event)"
                (mosItemOpen)="onMosItemOpen($event)"
                (mosMediaClicked)="onMosMediaClicked($event)"
                (approvedChanged)="onApprovedChanged($event)" />
            <div [class.st-story-item-full-screen-editor--content-hidden]="toggleEditor()">
                <button
                    class="st-story-item-full-screen__toggle-editor"
                    mat-button
                    (click)="toggleEditor.set(!toggleEditor())">
                    <mat-icon>arrow_back</mat-icon>
                    Back to Editor
                </button>
                <st-story-full-screen-properties
                    [data]="data()"
                    [sidecarMenu]="sidecarMenu()" />
            </div>
        }
    </div>
    @if ((loaderState() || isCodoxInitializing()) && !data()?.isNewRecord) {
        <div class="st-story-item-full-screen__progress-bar">
            <mat-progress-bar mode="indeterminate" />
        </div>
    }

    @if (toggleEditor()) {
        <div class="st-story-item-full-screen-footer">
            <div class="st-story-item-full-screen-footer-timings">
                @if (!collaborationEnabled() && lockLabel()) {
                    <div class="st-story-item-full-screen-footer-timings__lock-container">
                        @if (lockingInProgress()) {
                            <st-loader
                                class="st-story-item-full-screen-footer-timings__lock-container--spinner"
                                [diameter]="24"
                                [strokeWidth]="4" />
                        } @else {
                            @if (!isEditableByLock()) {
                                <mat-icon
                                    class="st-story-item-full-screen-footer-timings__lock-container--lock-icon"
                                    fontSet="material-symbols-outlined">
                                    lock
                                </mat-icon>
                            } @else if (isLockedSuccessfully() && isEditableByLock()) {
                                <mat-icon
                                    class="st-story-item-full-screen-footer-timings__lock-container--lock-icon"
                                    fontSet="material-symbols-outlined">
                                    lock_open
                                </mat-icon>
                            }
                            @if (loaderState() && !data()?.isNewRecord) {
                                <span>{{ languageSettings().PSTWebLoadingLabel }}</span>
                            } @else {
                                <span>{{ lockLabel() }}</span>
                            }
                        }
                    </div>
                }
                <span class="st-story-item-full-screen-footer-timings--wordsCount">{{ selectCurrentStoryWordsCount() }}</span>
                <span class="st-story-item-full-screen-footer-timings--actualTextTime">{{ storyTrTActualTextTime() }}</span>
                @if (selectCurrentStorySelectedReadRateTime()) {
                    <span class="st-story-item-full-screen-footer-timings--selectedTextTime">{{ languageSettings().PSTWebSelectedTextTime }} {{ selectCurrentStorySelectedReadRateTime() }}</span>
                }
            </div>
        </div>
    }
    @if (toggleEditor() && showAttachments()) {
        <mat-accordion
            #accordion
            class="st-story-item-full-screen-accordion"
            multi>
            <!-- TODO: This needs to be done with string template when we upgrade to Angular 19.2 and up.
            E.G. [expanded]="expandedState()?.[`{$sidecar()} ${attachmentsFiedGroupLabel()}`]" -->
            <st-expansion-panel
                #paneContainer
                class="st-story-item-full-screen-accordion-pane-container"
                [title]="attachmentsFieldGroupLabel()"
                [expanded]="expandedState()?.[sidecar() + attachmentsFieldGroupLabel()]"
                (panelStateChanged)="panelStateChanged($event, attachmentsFieldGroupLabel())">
                <span
                    title
                    class="st-expansion-panel-panel-header__title">
                    @if (!environment.demoModeNotForProduction) {
                        <st-beta class="st-expansion-panel-panel-header__beta" />
                    }
                    {{ attachmentsFieldGroupLabel() }}
                </span>
                <st-attachments-list
                    [disabled]="isDisabled()"
                    [record]="data()" />
                <ng-container actions>
                    <button
                        mat-icon-button
                        class="st-story-item-full-screen-accordion-pane-container-expand-collapse"
                        st-click-stop-propagation
                        [matTooltip]="paneContainer?.expanded ? collapseAllLabel() : expandAllLabel()"
                        (click)="expandCollapseAll(paneContainer)">
                        <mat-icon fontSet="material-symbols-outlined">{{ paneContainer?.expanded ? 'collapse_all' : 'expand_all' }}</mat-icon>
                    </button>
                </ng-container>
            </st-expansion-panel>
        </mat-accordion>
    }
</div>
